<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='文章域名'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-button type="primary" @click="showAddDialog">添加文章域名</el-button>&nbsp;
          <el-select v-model="param.is_use" placeholder="请选择是否使用" @change="search" filterable>
            <el-option label="全部" :value="0"></el-option>
            <el-option v-for="item in isUseList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.status" placeholder="请选择状态" @change="search" filterable>
            <el-option label="全部" :value="0"></el-option>
            <el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column prop="domain" label="域名" align="center"></el-table-column>
      <el-table-column label="是否使用" align="center">
        <template slot-scope="scope">
          {{scope.row.is_use | getTitleFromList(isUseList)}}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{scope.row.status | getTitleFromList(statusList)}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <article-domain-add :visible="addDialogAvaible"
      :id="currentId"
      :isUseList="isUseList"
      :statusList="statusList"
      @add="add"
      @update="update"
      @close="closeAddDialog">
    </article-domain-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ArticleDomainAdd from './ArticleDomainAdd.vue'
export default {
  name: 'category_list',
  components: {
    'bread-crumb': BreadCrumb,
    'article-domain-add': ArticleDomainAdd
  },
  data () {
    return {
      list: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        is_use: 0,
        status: 0,
        page: 1,
        count: 10
      },
      addDialogAvaible: false,
      isUseList: [
        { id: 1, title: '未使用' },
        { id: 2, title: '正在使用' }
      ],
      statusList: [
        { id: 1, title: '正常' },
        { id: 2, title: '被封' }
      ]
    }
  },
  created () {
    this.getList()
  },
  filters: {
    getTitleFromList (id, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          return list[i].title
        }
      }
      return ''
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/article_domain/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/article_domain/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async add (data) {
      const res = await this.$http.post('/admin/article_domain/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/article_domain/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
